import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
// import myAnalytics from './my-analytics'

// https://stackoverflow.com/questions/41742390/javascript-to-check-if-pwa-or-mobile-web
const analytics = Analytics({
  app: 'coronapulse',
  plugins: [
    // myAnalytics(),
    googleAnalytics({
      trackingId: 'UA-173745308-1',
    })
  ]
})

export default analytics
